import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-reward-modal',
  imports: [CommonModule],
  templateUrl: './reward-modal.component.html',
  styleUrl: './reward-modal.component.css'
})
export class RewardModalComponent {
  @Output() close = new EventEmitter<void>();
  amount = '';
  balance = 0; // available balance
  isInsufficient = false;

  onAmountChange(value: string) {
    this.amount = value;

    const enteredAmount = Number(value.replace(/[^0-9.]/g, ''));
    this.isInsufficient = enteredAmount > this.balance;
  }
}
